import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowLeft, ArrowRight, Home, Check } from "lucide-react";
import { useCourseProgress } from "../contexts/CourseProgressContext";

const ModuleNavigation = ({
  prevLink,
  prevText,
  nextLink,
  nextText,
  onMarkComplete,
  isCompleted = false,
  completeButtonId,
}) => {
  const location = useLocation();
  const { toggleModuleComplete, isModuleCompleted, moduleRoutes } =
    useCourseProgress();

  // Find the current module ID based on the path
  const currentModuleId = moduleRoutes.find(
    (route) => route.path === location.pathname
  )?.id;

  // Check if completed from context, fallback to prop for backward compatibility
  const moduleCompleted = currentModuleId
    ? isModuleCompleted(currentModuleId)
    : isCompleted;

  const handleMarkComplete = () => {
    // Toggle in context
    if (currentModuleId) {
      toggleModuleComplete(currentModuleId, !moduleCompleted);
    }

    // Call the original handler for backward compatibility
    if (onMarkComplete) {
      onMarkComplete(!moduleCompleted);
    }
  };

  return (
    <div className="flex justify-between items-center mt-12 border-t border-gray-200 pt-6">
      {/* Back to Home always on the left */}
      {prevLink === "/" ? (
        <Link
          to="/"
          className="flex items-center text-primary-500 hover:text-primary-700 mr-4"
        >
          <ArrowLeft className="mr-2 w-5 h-5" />
          Back to Home
        </Link>
      ) : (
        <Link
          to="/"
          className="flex items-center text-primary-500 hover:text-primary-700 mr-4"
        >
          <Home className="w-5 h-5 mr-1" />
          Home
        </Link>
      )}

      <div className="flex items-center space-x-4">
        {/* Only show Previous if it's not the home page */}
        {prevLink && prevLink !== "/" && (
          <Link
            to={prevLink}
            className="flex items-center text-primary-500 hover:text-primary-700"
          >
            <ArrowLeft className="mr-2 w-5 h-5" />
            {prevText || "Previous"}
          </Link>
        )}

        {/* Always show Mark as Complete button */}
        <button
          id={completeButtonId}
          onClick={handleMarkComplete}
          className={`flex items-center px-4 py-2 rounded-lg border transition-colors ${
            moduleCompleted
              ? "bg-status-success text-white border-transparent"
              : "border-primary-500 text-primary-500 hover:bg-primary-100"
          }`}
        >
          <Check className="w-4 h-4 mr-2" />
          {moduleCompleted ? "Completed" : "Mark as Complete"}
        </button>

        {nextLink && (
          <Link
            to={nextLink}
            className="flex items-center bg-primary-500 text-white px-4 py-2 rounded-lg hover:bg-primary-700"
          >
            {nextText || "Next"}
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        )}
      </div>
    </div>
  );
};

export default ModuleNavigation;
